import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from "@mui/material";
import { useTranslation } from "react-i18next";

type P = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
};

export function VisitorBookingsCheckInWithoutConsentDialog({
  open,
  onClose,
  onConfirm
}: Readonly<P>) {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="visitor-check-in-without-consent-title"
      data-testid="visitor-bookings-check-in-without-consent-dialog"
    >
      <DialogTitle id="visitor-check-in-without-consent-title">
        {t("_visitorBookings_checkInWithoutConsentTitle")}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>{t("_visitorBookings_checkInWithoutConsentBody")}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          data-testid="visitor-check-in-without-consent-cancel"
          color="secondary"
        >
          {t("_visitorBookings_checkInWithoutConsentCancel")}
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="warning"
          data-testid="visitor-check-in-without-consent-confirm"
        >
          {t("_visitorBookings_checkInWithoutConsentConfirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
